<template lang="pug">
.news(
  :style="{height: height}")
  b-header
  .container(
    ref="fullpage",
    v-fullpage="opts",
    @mousewheel.stop.prevent="mousewheel"
    @wheel.stop.prevent="mousewheel")
    .page(:style="{height: height}", v-if="!mobi")
      .nav
        transition(name="left-in")
          .line(v-show="init")
        transition(name="right-in")
          .title(v-show="init") {{langs[lang].news}}
      transition(name="top-in")
        .detail(v-show="init", @click="openLink(newsList[0].link)")
          .title {{newsList[0] && newsList[0].title}}
          .content(v-html="newsList[0] && newsList[0].content")
    .page(:style="{height: height}")
      .bg.pc
      .items
        transition-group(
          appear,
          @before-enter="beforeEnter",
          @enter="enter",
          mode="out-in")
          .item(
            :key="index",
            :data-index="index",
            :style="{background: `url(${item.img}) center / auto 100%`}",
            @click="openLink(item.link)",
            v-for="(item, index) in newsList")
            .mask.mask_1
            .mask
            .more {{langs[lang].more}}
            .content
              .time {{item.date | time}}
              .title {{item.title}}
              //- .logo
                img(:src="item.media_logo")
                | {{item.media}}
      .morenews.pc(
        @click="morenews") {{langs[lang].moreNews}}
    .page.pc(
      v-if="!mobi"
      :style="{height: height}")
      .newslist(
        ref="iteam"
        @mousewheel.stop="moremousewheel"
        )
        .list(
          @click="openLink(item.link)",
          v-for="(item, index) in oldNewsList")
          img.img(:src="item.img")
          .content
            .title {{item.title}}
            span.date {{item.date | time}}
            span.media {{item.media}}
</template>

<script>
import footer from './footer.vue'
import header from './header.vue'
import fanpage from '../mixin/fanpage.js'
const News = {
  mixins: [fanpage],
  props: [],
  data () {
    return {
      newsList: [],
      oldNewsList: [],
      langs: {
        en: {
          news: 'NEWS',
          more: 'LEARN MORE',
          moreNews: 'More News'
        },
        zh: {
          news: '新闻',
          more: '了解更多',
          moreNews: '更多新闻'
        }
      }
    }
  },
  filters: {
    time (date) {
      return date.slice(0, 7)
    }
  },
  mounted () {
    let _this = this
    let lang = ''
    document.body.scrollTop = 0
    if (_this.lang === 'zh') {
      lang = 54
    } else {
      lang = 56
    }
    window.$http.get(window.hostName + `wp-json/wp/v2/news?page=1&per_page=30&tags=${lang}`).then(res => {
      var allnews = res.data.map(item => {
        return {
          img: item.image.guid,
          title: item.title.rendered,
          content: item.content.rendered,
          link: item.link,
          media_logo: item.media_logo.guid,
          media: item.media,
          date: item.date,
          tags: item.tags
        }
      })
      _this.newsList = allnews.slice(0, 6)
      _this.oldNewsList = allnews.slice(6, -1)
    })
  },
  components: {
    bFooter: footer,
    bHeader: header
  },
  computed: {
    lang () {
      return localStorage.lang
    },
    mobi () {
      return window.isMobi
    },
    totalPage () {
      return this.mobi ? 0 : 1
    }
  },
  methods: {
    openLink (link) {
      window.open(link)
    },
    beforeEnter: function (el) {
      window.Velocity.hook(el, 'scale', 0)
      window.Velocity.hook(el, 'opacity', 0)
    },
    enter: function (el, done) {
      window.Velocity(
        el,
        {
          opacity: 1,
          scale: 1
        },
        {
          duration: 1000,
          easing: 'easeOutBounce',
          complete: done
        }
      )
    },
    morenews: function (el) {
      this.turnTo(2)
    },
    moremousewheel: function (el) {
      let top = this.$refs.iteam.scrollTop
      if (top <= 0 && el.deltaY < 0 || top >= this.$refs.iteam.scrollHeight - this.$refs.iteam.clientHeight && el.deltaY > 0) {
        this.mousewheel(el)
      }
      return el
    }
  }
}
export default News
</script>

<style scoped lang="stylus">
@import '../common.styl'
@media (max-width: 720px) {
  .news{
    .detail{
      width: 1430px;
      height: 424px;
      border: 1px solid #002b69;/*no*/
      color: #002b69;
      margin: 100px auto 20px;
      padding: 50px;
      .title{
        font-size: 36px;/*no*/
        font-weight: bold;
        margin-bottom: 50px;
      }
      .content{
        font-size: 16px;/*no*/
      }
    }
    .items{
      width: 100%;
      height: 100vh;
      margin-left: 3%;
      margin-top: 60px;/*no*/
      .item{
        position: relative;
        float: left;
        width: 45%;
        margin-right: 3%;
        height: 180px;/*no*/
        overflow: hidden;
        margin-bottom: 30px;
        background: url(http://via.placeholder.com/352x420) center / cover;
        color: #fff;
        border-bottom: 10px solid red;
        &:hover{
          .mask{

          }
        }
        .content{
          width: 100%;
          height: 100%;
          padding: 50px 30px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          .time{
            font-size: 24px;/*no*/
            text-align: left;
            margin-left: 10px;/*no*/
            margin-top: 30px;/*no*/
            border-bottom: 2px solid #fff;
          }
          .title{
            margin-left: 10px;/*no*/
            font-size: 8px;/*no*/
            font-weight: bold;
            margin-top: 20px;
          }
          .logo{
            text-align: center;
            font-size: 8px;/*no*/
            margin-top: 80px;
            line-height: 14px;
            img{
              margin-right: 20px;
              width: 14px;/*no*/
              height: 14px;/*no*/
              border-radius: 50%;
              vertical-align: middle;
            }
          }
        }
        .more{
          position: absolute;
          bottom: 0;
          left: 0;
          font-size: 12px;/*no*/
          font-weight: lighter;
          width: 100%;
          color: #eee;
          height: 32px;/*no*/
          line-height: 32px;/*no*/
          text-align: center;
          background: url('../assets/bg_blue.png') center / cover;
        }
        .mask{
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0,43,105,0.8);
        }
      }
    }
  }
}
@media (min-width: 720px) {
  .detail{
    cursor: pointer;
    width: 1430px;
    height: 424px;
    border: 1px solid #002b69;/*no*/
    color: #002b69;
    margin: 100px auto 20px;
    padding: 50px;
    .title{
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .content{
      font-size: 20px;
      line-height: 2;
    }
  }
  .bg{
    width: 100%;
    height: 750px;
    padding-bottom: 300px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #e6e6e6;
    z-index: -1;
  }
  .items{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1116px;
    .item{
      position: relative;
      overflow: hidden;
      height: 420px;
      width: 352px;
      margin-bottom: 30px;
      float: left;
      margin-right: 30px;
      color: #fff;
      border-bottom: 4px solid red;
      transition: all 1s;
      &:hover{
        cursor: pointer;
        background-origin: center;
        background-size: auto 150%!important;
        .more{
          bottom: 0;
        }
        .mask_1{
          top: -100%;
        }
      }
      &:nth-child(3n+3){
        margin-right: 0;
      }
      .content{
        width: 100%;
        height: 100%;
        padding: 50px 30px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        .time{
          font-size: 12px;/*no*/
          text-align: center;
          width: 84px;
          margin: 0 auto;
          margin-top: 10px;
          border-bottom: 2px solid #fff;
        }
        .title{
          font-size: 18px;
          font-weight: bold;
          width: 300px;
          text-align: center;
          margin-top: 80px;
        }
        .logo{
          text-align: center;
          font-size: 18px;
          margin-top: 80px;
          line-height: 28px;
          img{
            margin-right: 20px;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            vertical-align: bottom;
          }
        }
      }
      .more{
        position: absolute;
        bottom: -52px;
        left: 0;
        font-size: 12px;/*no*/
        font-weight: lighter;
        width: 100%;
        color: #eee;
        height: 52px;
        line-height: 52px;
        text-align: center;
        background: url('../assets/bg_blue.png') center / cover;
        transition: all .5s;
      }
      .mask{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: .5;
        background-color: rgba(0,43,105,0.8);
        transition: all .5s;
      }
      .mask_1{
        opacity: .9;
      }
    }
  }
  .morenews{
    width: 10%;
    background-color: #e6e6e6;
    color: #082865;
    text-decoration: underline;
    font-size: 28px;
    text-align: center;
    width: 100%;
    position: absolute;
    cursor: pointer;
    bottom: 20px;
    left: 50%;
    transform translateX(-50%)
  }
  .newslist{
    overflow-y: scroll;
    position: relative;
    top: 20%;
    height: 80%;
    .list{
      cursor: pointer;
      width: 50%;
      margin: 0 auto 20px;
      font-size: 24px;
      color: #0b274e;
      border: 2px solid #8199b1;
      overflow: hidden;
      .img{
        height: 120px;
        width: 17%;
        margin-right: 20px;
        float: left;
      }
      .content{
        padding: 20px 0;
        float: left;
        width: 80%;
      }
      .title{
        margin-bottom: 10px;
        -o-text-overflow: ellipsis;/*兼容opera*/
        text-overflow: ellipsis;/*这就是省略号喽*/
        overflow: hidden;/*设置超过的隐藏*/
        white-space: nowrap;/*设置不折行*/
      }
      .date{
        margin-right: 20px;
        font-weight: bold;
      }
      .media{
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// news.vue?3962f8e8